import {getEnv} from "../env";
import {callApi, updateStatus} from "../05-utils/commonUtils";

const ACTIONS = {
  LOGIN_PROGRESS: "LOGIN_PROGRESS",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAILED: "LOGIN_FAILED",
  REGISTER_PROGRESS: "REGISTER_PROGRESS",
  REGISTER_SUCCESS: "REGISTER_SUCCESS",
  REGISTER_FAILED: "REGISTER_FAILED",
  LOGOUT: "LOGOUT",
};

const login = (loginData) => {
  let config = {
    method: "post",
    body: {
      username: loginData.username,
      password: loginData.password,
    },
  };

  return (dispatch) => {
    dispatch(updateStatus(ACTIONS.LOGIN_PROGRESS));
    callApi(
      getEnv("API_SERVER") + "/login",
      config,
      null,
      (data) => {
        dispatch(updateStatus(ACTIONS.LOGIN_SUCCESS, {user: data}));
      },
      (err) => {
        dispatch(updateStatus(ACTIONS.LOGIN_FAILED, {error: err}));
      },
    );
  };
};

const register = (registerData) => {
  let config = {
    method: "post",
    body: {
      username: registerData.username,
      authMethod: "password",
      authInfo: [registerData.password],
    },
  };

  return (dispatch) => {
    dispatch(updateStatus(ACTIONS.REGISTER_PROGRESS));
    callApi(
      getEnv("API_SERVER") + "/register",
      config,
      null,
      () => {
        dispatch(updateStatus(ACTIONS.REGISTER_SUCCESS));
      },
      (err) => {
        dispatch(updateStatus(ACTIONS.REGISTER_FAILED, {error: err}));
      },
    );
  };
};

const logout = () => {
  return {
    type: ACTIONS.LOGOUT,
  };
};

export {ACTIONS, login, register, logout};



// WEBPACK FOOTER //
// ./src/01-actions/auth.js